export function toggleArray<T extends string | number>(
  data: T[],
  toggleItem: T
): T[]
export function toggleArray<T extends Record<string, unknown>, K extends keyof T>(
  data: T[],
  toggleItem: T,
  key: K
): T[]
export function toggleArray<T>(
  data: T[],
  toggleItem: T,
  key?: keyof T
): T[] {
  if (typeof toggleItem === 'string' || typeof toggleItem === 'number') {
    return data.includes(toggleItem)
      ? data.filter((item) => item !== toggleItem)
      : [...data, toggleItem];
  }

  if (!key) {
    throw new Error('Key is required for object toggling');
  }
  
  return data.some(item => item[key] === toggleItem[key])
    ? data.filter(item => item[key] !== toggleItem[key])
    : [...data, toggleItem];
}